import useGlobalModel from '@/model/globalModel'
import { Checkbox, message, Switch, Table, Tooltip } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useEffect, useRef, useState } from 'react'
import { globalPrompt } from '@/components/message'
import { EditableCell, EditableRow } from '@/components/YHEditTable/editTable'
import { YHModal } from '@/components/YHModal'
import logo from '@/assets/images/icon-question.png'
import { threeInspectionSchedulingModel } from '../schedulingModel'
import { schedulingService } from '../schedulingService'

export const AddSchedulingModal = () => {
    const [dataSource, setDataSource] = useState<any>([])
    const { addCarVisible, setAddCarVisible, loadData } = threeInspectionSchedulingModel()
    const formRef = useRef<any>()
    const {
        user: { shopCode, createUser },
        vehicleData,
        trailerData,
        driverData,
        supercargoData,
        routineData,
    } = useGlobalModel(({ user }) => [user])
    const [saveLoading, setSaveLoading] = useState<boolean>(false)
    const [autoScheduling, setAutoScheduling] = useState<boolean>(false)
    const [fatigue, setFatigue] = useState<string>('YES')
    const [alcoholTesting, setAlcoholTesting] = useState<string>('NO')

    useEffect(() => {
        setDataSource([
            {
                longStatus: true,
                temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
                automaticScheduling: 0,
                createUserId: shopCode,
                createUser: createUser,
                notificationStatus: 1,
                dualDrivers: 0,
                fatigue: fatigue,
                alcoholTesting: alcoholTesting,
            },
        ])
    }, [addCarVisible, alcoholTesting, createUser, fatigue, shopCode])
    useEffect(() => {
        formRef.current = dataSource
    }, [dataSource])
    const DeleteRow = (record: any) => {
        const data = formRef.current.filter((i: any) => record.temporaryId !== i.temporaryId)
        setDataSource(data)
    }
    const AddRow = (record: any) => {
        const dataIndex = formRef.current.findIndex((i: any) => record.temporaryId === i.temporaryId)
        const newData = dataSource
        newData.splice(dataIndex + 1, 0, {
            longStatus: true,
            temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
            createUserId: shopCode,
            createUser: createUser,
            notificationStatus: 1,
            automaticScheduling: 0,
            fatigue: fatigue,
            alcoholTesting: alcoholTesting,
        })
        setDataSource([...newData])
    }
    const columns = [
        {
            title: '操作',
            width: 140,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any) => (
                <>
                    {dataSource?.length > 1 && (
                        <span
                            style={{
                                fontSize: '14px',
                                color: '#4165E3',
                                cursor: 'pointer',
                            }}
                            onClick={() => DeleteRow(r)}
                        >
                            删除
                        </span>
                    )}
                    <span
                        style={{
                            fontSize: '14px',
                            color: '#4165E3',
                            cursor: 'pointer',
                            marginLeft: '15px',
                        }}
                        onClick={() => AddRow(r)}
                    >
                        新增一行
                    </span>
                </>
            ),
        },
        {
            title: '自动排班',
            dataIndex: 'automaticScheduling',
            align: 'center',
            width: 100,
            render: (text: any, record: any) => (
                <Switch
                    checkedChildren="开启"
                    unCheckedChildren="关闭"
                    checked={text === 1 ? true : false}
                    onChange={(checked: boolean) => {
                        handleSave({
                            ...record,
                            automaticScheduling: checked ? 1 : 0,
                            changeFields: 'automaticScheduling',
                        })
                        if (checked === false) {
                            setAutoScheduling(false)
                        }
                    }}
                />
            ),
        },
        {
            title: (
                <span>
                    司机 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 120,
            dataIndex: 'driverId',
            editable: true,
            align: 'center',
            editType: 'select',
            options: driverData,
            render: (text: string) => driverData.find((item) => item.value === text)?.label ?? '',
        },
        {
            title: '押运员',
            width: 120,
            dataIndex: 'escortId',
            editable: true,
            align: 'center',
            editType: 'select',
            options: [...supercargoData, ...driverData],
            render: (text: string) => [...supercargoData, ...driverData].find((item) => item.value === text)?.label ?? '',
        },
        {
            title: (
                <span>
                    车头 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 120,
            dataIndex: 'vehicleId',
            editable: true,
            align: 'center',
            editType: 'select',
            options: vehicleData,
            render: (text: string) => vehicleData.find((item) => item.value === text)?.label ?? '',
        },
        {
            title: '挂车',
            width: 120,
            dataIndex: 'trailerId',
            editable: true,
            align: 'center',
            editType: 'select',
            options: trailerData,
            render: (text: string) => trailerData.find((item) => item.value === text)?.label ?? '',
        },
        {
            title: (
                <span>
                    时间 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 300,
            dataIndex: 'departureTime',
            format: 'YYYY-MM-DD HH:mm:ss',
            editable: true,
            align: 'center',
            editType: 'nowdatepicker',
            render: (text: any) =>
                text instanceof Array
                    ? [text[0]?.format('YYYY-MM-DD HH:mm:ss'), '⇌', text[1].format('YYYY-MM-DD HH:mm:ss')]
                    : text?.format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: '路线',
            width: 120,
            dataIndex: 'lineName',
            editable: true,
            align: 'center',
            editType: 'select',
            options: routineData,
        },
        {
            title: '创建人',
            width: 200,
            dataIndex: 'createUser',
            align: 'center',
            // editable: true,
        },
    ]

    //内联编辑
    const handleSave = (row: any) => {
        const newData = [...dataSource]
        const index = newData.findIndex((item) => row.temporaryId === item.temporaryId)
        const item = newData[index]
        if (row['changeFields'] === 'longStatus') {
            row.departureTime = undefined
            row.departureEndTime = undefined
        }
        // if(row['changeFields']=='departureTime'){
        //     if(row.departureTime instanceof Array){
        //         row.departureTime=row.departureTime[0]
        //         row.departureEndTime=row.departureTime[1]
        //     }else{
        //         row.departureTime=row.departureTime
        //     }
        // }
        newData.splice(index, 1, {
            ...item,
            ...row,
            departureTime: row.departureTime,
            departureEndTime: row.departureEndTime,
            driverName: row.driverId ? driverData.find((item) => item.value === row.driverId)?.label : '',
            trailerNumber: row.trailerId ? trailerData.find((item) => item.value === row.trailerId)?.label : '',
            vehicleNumber: row.vehicleId ? vehicleData.find((item) => item.value === row.vehicleId)?.label : '',
            escortName: row.escortId ? [...supercargoData, ...driverData].find((item) => item.value === row.escortId)?.label : '',
            dualDrivers: [...supercargoData, ...driverData].find((item) => item?.value === row?.escortId)?.type === '司机' ? 1 : 0,
            lineName: row.lineName ? routineData.find((item) => item.value === row.lineName)?.label : '',
            md5: row.driverId ? driverData.find((item) => item.value === row.driverId)?.md5 : '',
            photo: row.driverId ? driverData.find((item) => item.value === row.driverId)?.photo : '',
            longStatus: row.longStatus,
        })
        setDataSource(newData)
    }

    const onOk = async () => {
        let errorList: any = []
        let newlist: any = []
        dataSource.forEach((item: any) => {
            if (item.driverId && item.vehicleId && item.departureTime) {
                newlist.push({
                    ...item,
                    departureTime:
                        item.departureTime instanceof Array
                            ? item.departureTime[0].format('YYYY-MM-DD HH:mm:ss')
                            : item.departureTime.format('YYYY-MM-DD HH:mm:ss'),
                    departureEndTime: item.departureTime instanceof Array ? item.departureTime[1].format('YYYY-MM-DD HH:mm:ss') : '',
                })
                return
            } else {
                errorList.push(item.driverName)
            }
        })
        if (errorList?.length > 0) {
            return message.warning(`请补全${errorList}必填信息，再继续操作！`)
        }
        try {
            setSaveLoading(true)
            let { retData } = await schedulingService.insert(newlist)
            setSaveLoading(false)
            setAddCarVisible(false)
            message.success(`添加成功！`)
            loadData()
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    }

    const onClose = () => {
        globalPrompt('modal', {
            title: '新增排班',
            type: 'warning',
            text: '您还有正在新增的排班记录...是否关闭？',
            okText: '关闭页面',
            onOk: () => setAddCarVisible(false),
            cancelText: '继续添加',
            onCancel: () => {
                return
            },
        })
    }
    const changeScheduling = (val) => {
        globalPrompt('modal', {
            title: '自动排班',
            type: 'warning',
            text: `此步操作会${val ? '开启' : '关闭'}所有自动排班？`,
            okText: '确定',
            onOk: () => {
                let newData = dataSource.map((item) => ({
                    ...item,
                    automaticScheduling: val ? 1 : 0,
                }))
                setDataSource(newData)
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    const changeFatigue = (val) => {
        globalPrompt('modal', {
            title: '疲劳检测',
            type: 'warning',
            text: `此步操作会${val ? '开启' : '关闭'}疲劳检测？`,
            okText: '确定',
            onOk: () => {
                let newData = dataSource.map((item: any) => ({
                    ...item,
                    fatigue: val ? 'YES' : 'NO',
                }))
                setDataSource(newData)
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    const changeAlcohol = (val) => {
        globalPrompt('modal', {
            title: '酒精检测',
            type: 'warning',
            text: `此步操作会${val ? '开启' : '关闭'}酒精检测？`,
            okText: '确定',
            onOk: () => {
                let newData = dataSource.map((item) => ({
                    ...item,
                    alcoholTesting: val ? 'YES' : 'NO',
                }))
                setDataSource(newData)
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    return (
        <YHModal
            visible={addCarVisible}
            title="您正在添加排班..."
            cancelText="取消添加"
            okText="确定添加"
            onCancel={onClose}
            onOk={onOk}
            width={'70%'}
            showFooter={true}
        >
            <div style={{ float: 'right', margin: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                <Checkbox
                    style={{ marginRight: '20px', lineHeight: '30px' }}
                    onChange={(e) => {
                        setAlcoholTesting(e.target.checked ? 'YES' : 'NO')
                        changeAlcohol(e.target.checked)
                    }}
                    checked={alcoholTesting === 'YES'}
                >
                    <span style={{ fontSize: '17px', fontWeight: 'bolder' }}>酒精检测</span>
                </Checkbox>
                <Checkbox
                    style={{ marginRight: '20px', lineHeight: '30px' }}
                    onChange={(e) => {
                        setFatigue(e.target.checked ? 'YES' : 'NO')
                        changeFatigue(e.target.checked)
                    }}
                    checked={fatigue === 'YES'}
                >
                    <span style={{ fontSize: '17px', fontWeight: 'bolder' }}>疲劳检测</span>
                </Checkbox>
                <Switch
                    style={{ marginRight: '10px',  }}
                    checkedChildren="开启"
                    unCheckedChildren="关闭"
                    checked={autoScheduling || (dataSource?.length > 0 && !dataSource.find((item) => item.automaticScheduling * 1 === 0))}
                    onChange={(checked: boolean) => {
                        setAutoScheduling(checked)
                        changeScheduling(checked)
                    }}
                ></Switch>

                <p
                    className="floating-text"
                    style={{
                        fontSize: '16px',
                        margin: '0',
                        color: '#3b62e8',
                        fontWeight: 'bolder',
                        lineHeight: '32px',
                    }}
                >
                    自动排班
                </p>
                <Tooltip placement="top" title="本操作可开启顺延排班！">
                    <img src={logo} style={{ width: '15px', height: '15px', margin: '2px 0 0 5px', cursor: 'pointer' }} alt="" />
                </Tooltip>
            </div>
            <Table
                loading={saveLoading}
                rowKey={(record) => record.temporaryId}
                columns={
                    columns.map((col: any, index) => {
                        return {
                            ...col,
                            onCell: (record: any, rowIndex: number) => {
                                let type = ''
                                if (col.editType === 'nowdatepicker' && record.longStatus) {
                                    type = 'longDatepicker'
                                } else {
                                    type = col.editType
                                }
                                return {
                                    colIndex: index + 1,
                                    rowIndex,
                                    record,
                                    rules: col.rules,
                                    options: col.options,
                                    editType: type,
                                    editable: col?.editable,
                                    dataIndex: col.dataIndex,
                                    title: col.title,
                                    handleSave: handleSave,
                                    onInputEnter: col.onInputEnter,
                                }
                            },
                        }
                    }) as ColumnsType<any>
                }
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                dataSource={dataSource}
                scroll={{ x: 'max-content' }}
                pagination={false}
                bordered
                // footer={() => <span style={{ color: '#999999', cursor: 'pointer' }} onClick={() => AddRow()}><PlusOutlined />新增一行</span>}
            />
        </YHModal>
    )
}
